import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './help.scss';
import AboutPopup from '../about';
import TipsPopup from './tips';
import DesignGuidelines from '../ro-input/design-guildlines';

function Help(props) {
  const { translateObject } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [arrowDir, setArrowDir] = React.useState(false);
  const [visibleAbout, setVisibleAbout] = React.useState(false);
  const [visibleRoTips, setVisibleRoTips] = React.useState(false);
  const [visibleDG, setVisibleDG] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleHelpClick = (event) => {
    setArrowDir(!arrowDir);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setArrowDir(false);
    setAnchorEl(null);
  };
  const aboutPopup = () => {
    setVisibleAbout(true);
    handleClose(); // closing menulist
  };
  const handleRoTipsPopup = () => {
    setVisibleRoTips(true);
    handleClose(); // closing menulist
  };
  const closeRoTipsPopup = () => {
    setVisibleRoTips(false); // closing ro design guidlines tips
  };
  const closeAboutPopup = () => {
    setVisibleAbout(false); // closing about popup
  };
  const handleCloseDG = () => {
    setVisibleDG(false); // closing design guide line popup
    localStorage.removeItem('previousUnits'); // removing Previous units in local storage
  };
  const designGuidline = () => { // when we clik on design guidelines
    setVisibleDG(true); // opening design guide line popup
    handleClose(); // closing menulist
  };
  const referance_list = () => {
    const link = document.createElement('a'); // creating ancher tag
    document.body.appendChild(link); // appending to body
    // Changed to read help document URL from env configuration.
    link.href = process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL; // adding href to ancher tag
    link.click(); // performaning click action
    document.body.removeChild(link); // removing appended ancher tag
    handleClose(); // closing menulist
  };
  return (
    <div>
      <Button
        id="help-button"
        style={{ fontFamily: '' }}
        className=''
        disableElevation
        onClick={handleHelpClick}
        endIcon={arrowDir ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      >
        {translateObject('Help')}
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem className='help_list' onClick={designGuidline}>{translateObject('Design Guidelines')}</MenuItem>
        <MenuItem className='help_list' onClick={handleRoTipsPopup}>{translateObject('RO Design Guidelines Tips')}</MenuItem>
        <MenuItem className='help_list' onClick={referance_list}>{translateObject('Element Cross Reference List')}</MenuItem>
        <MenuItem className='help_list' onClick={aboutPopup}>{translateObject('About')}</MenuItem>
      </Menu>
      {visibleAbout && (
        <AboutPopup
          visibleAbout={visibleAbout}
          closeAboutPopup={closeAboutPopup}
          translateObject={translateObject}
        />
      )}
      {visibleRoTips && (
        <TipsPopup
          visibleRoTips={visibleRoTips}
          closeRoTipsPopup={closeRoTipsPopup}
          translateObject={translateObject}
        />
      )}
      {visibleDG && (
        <DesignGuidelines
          visibleDG={visibleDG}
          handleCloseDG={handleCloseDG}
          translateObject={translateObject}
        />
      )}
    </div>
  );
}

export default Help;
